import { Entity, Field } from 'typegraph';

@Entity({ update: "enrollmentCountUpdate" })
export class OrganizationUserEnrollment {

    @Field()
	id: number;

}


// WEBPACK FOOTER //
// ./src/panels/bundleEntries/entities/OrganizationUserEnrollment.ts